<template>
    <div class="commission-report">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Monthly Commission Report</h2>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-card no-body>
                <!-- HEADER -->
                <b-card-header class="border-0">
                    <b-row></b-row>
                </b-card-header>

                <!-- SEARCH INPUT -->
                <b-col cols="12">
                    <b-row class="d-flex align-items-center">
                        <b-col cols="12" md="6" class="d-md-flex">
                            <base-input
                            label="Search"
                            v-model="searchQuery"
                            v-on:input="debouncedHandler"
                            prepend-icon="fas fa-search"
                            placeholder="Search..."
                            >
                            </base-input>
                            <base-input label="Date" class="mx-4">
                                <el-date-picker
                                v-model="datePicked"
                                type="month"
                                format="MMMM yyyy"
                                placeholder="Pick a month">
                                </el-date-picker>
                            </base-input>
                        </b-col>
                    </b-row>
                </b-col>

                <!-- TABLE LIST -->
                <div class="table-listings">
                    <el-table 
                        ref="multipleTable"
                        v-loading="isTableLoading"
                        :data="queriedData"
                        style="width: 100%;"
                        @selection-change="selectionChange"
                    >

                        <el-table-column
                            type="selection"
                            width="35"
                            fixed
                            class-name="px-2"
                        ></el-table-column>

                        <!-- NAME COLUMN -->
                        <el-table-column
                            prop="staff_name"
                            label="Staff Name"
                            min-width="200"
                            sortable
                        >
                            <template slot-scope="scope">
                                <p class="top-line">
                                    {{ scope.row.staff_name }}
                                </p>
                                <p class="bottom-line">
                                    {{ scope.row.username }}
                                </p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Jan"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[0].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            label="Feb"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[1].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="March"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[2].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Apr"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[3].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="May"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[4].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="June"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[5].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="July"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[6].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Aug"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[7].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Sept"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[8].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Oct"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[9].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Nov"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[10].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="Dec"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.commission_by_month[11].commission_paid | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="2022 - Total"
                            width="150"
                            sortable
                        >
                            <template slot-scope="scope">
                                <div class="d-flex justify-content-between">
                                    <p class="top-line">RM</p>
                                    <p class="top-line">
                                        {{ scope.row.total_commission | moneyFormatter }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- FOOTER -->
                <div
                    slot="footer"
                    class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
                >
                    <div class="d-flex align-items-center mb-3">
                        <p class="card-category mb-0 text-secondary">
                            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                
                            <span v-if="selectedRows.length">
                                &nbsp; &nbsp; {{selectedRows.length}} rows selected
                            </span>
                        </p>

                        <span class="mb-0 ml-4">Rows:</span>

                        <el-select
                            class="select-primary pagination-select mx-2"
                            v-model="pagination.perPage"
                            placeholder="Per page"
                        >
                            <el-option
                                class="select-primary"
                                v-for="item in pagination.perPageOptions"
                                :key="item"
                                :label="item"
                                :value="item"
                            >
                            </el-option>
                        </el-select>
            
                    </div>
                    <base-pagination
                        class="pagination-no-border"
                        :current="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                        @change="paginationChanged($event)"
                    >
                    </base-pagination>
                </div>
            </b-card>
        </b-container>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DatePicker } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['staff_name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [
                {
                    staff_name: 'Lee Wai Kee (Jeremy)',
                    username: 'Jeremy Lee',
                    commission_by_month: [
                        {
                            month: '01-2022',
                            commission_paid: 53425,
                        },
                        {
                            month: '02-2022',
                            commission_paid: 2134,
                        },
                        {
                            month: '03-2022',
                            commission_paid: 436,
                        },
                        {
                            month: '04-2022',
                            commission_paid: 23,
                        },
                        {
                            month: '05-2022',
                            commission_paid: 6832,
                        },
                        {
                            month: '06-2022',
                            commission_paid: 7357,
                        },
                        {
                            month: '07-2022',
                            commission_paid: 2134,
                        },
                        {
                            month: '08-2022',
                            commission_paid: 436,
                        },
                        {
                            month: '09-2022',
                            commission_paid: 23,
                        },
                        {
                            month: '10-2022',
                            commission_paid: 6832,
                        },
                        {
                            month: '11-2022',
                            commission_paid: 7357,
                        },
                        {
                            month: '12-2022',
                            commission_paid: 35,
                        },
                    ],
                    total_commission: 100000,
                },
            ],
            datePicked: ''
        }
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
    }
}
</script>